export default class Work {

    constructor(work) {
        const keys = Object.keys((work==null)?{}:work);
        this.company_name = (keys.includes("contractor_company_name"))? work.contractor_company_name: "";
        this.occupation = (keys.includes("contractor_occupation"))? work.contractor_occupation: "";
        this.annual_amount = (keys.includes("contractor_annual_amount"))? work.contractor_annual_amount: "";
    }
    
}